import axios from 'axios';
import { getApiBaseUrl } from '../utils/apiBaseUrl';

const API_BASE_URL = getApiBaseUrl();

export interface PaintingDateResponse {
    date: string | null;
}

export const getPaintingDate = async (id: string): Promise<PaintingDateResponse> => {
    const response = await axios.get<PaintingDateResponse>(`${API_BASE_URL}/paintings/${id}/date`);
    return response.data;
};

export const patchPaintingDate = async (id: string, date: string | null): Promise<PaintingDateResponse> => {
    const response = await axios.patch<PaintingDateResponse>(`${API_BASE_URL}/paintings/${id}/date`, { date });
    return response.data;
};

export const getPaintingText = async (id: string) => {
    const { data } = await axios.get(`${API_BASE_URL}/paintings/${id}/text`);
    return data;
};

export const patchPaintingText = async (id: string, text: string | null) => {
    const { data } = await axios.patch(`${API_BASE_URL}/paintings/${id}/text`, { text });
    return data;
};
